<template>
  <v-app>
    <UserAccounts />
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 class="text-center">
            <!-- <img src="../../../assets/images/uno-logo.png" class="form-head-logo mb-2" /> -->
            <v-card class="elevation-12">
              <offset-heading titleClass="text-sm-center font-weight-bold" title="LOGIN"></offset-heading>
              <v-card-text class="px-5">
                <v-form ref="loginForm" lazy-validation>
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    prepend-icon="fas fa-user-circle"
                    name="login"
                    label="Login"
                    required
                    validate-on-blur
                    @keyup.enter="login($event)"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="user.password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    validate-on-blur
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="login($event)"
                  ></v-text-field>
                  <div class="px-5">
                    <v-layout row wrap justify-center>
                      <v-btn submit color="primary" d-inline-flex fab medium @click="login($event)">
                        <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                      </v-btn>
                    </v-layout>
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import axios from 'axios'
// import { URL, apiToken } from '@/store/modules/auth/env'
import UserAccounts from '@/components/pages/login/UserAccount'

export default {
  components: {
    UserAccounts
  },
  data () {
    return {
      showPassword: false,
      user: {
        email: '',
        password: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be more than 8 characters'
      ],
      passwordCheckRules: [v => !!v || 'Password is required']
    }
  },

  async mounted () {
    // localStorage.clear()
    if (this.$route.query.token) {
      this.spinner(true)
      console.log(this.$route.query.token)
      this.va_loginWithToken(this.$route.query.token)
        .then(async res => {
          console.log(res)
          // actions after logging in
          await this.$store.dispatch('business/fetchUserBusinessList')
          if (res.active_business) {
            await this.$store.dispatch('business/getBusinessBranding', res.active_business.id) // fetch branding
            // set branding theme
            if (this.branding) {
              this.$vuetify.theme.themes.light.primary = this.branding.primary_color
              this.$vuetify.theme.themes.light.secondary = this.branding.secondary_color
              this.$vuetify.theme.themes.light.accent = this.branding.accent_color
              this.$router.push('/locations')
            }
          } else {
            this.$root.selectBusinessModal = true
          }
          this.spinner(false)
        })
        .catch(e => {
          this.spinner(false)
          return e
        })
    }
    this.spinner(false)
  },

  methods: {
    ...mapActions({
      va_login: 'auth/loginUser',
      va_loginWithToken: 'auth/loginWithToken'
    }),
    async login () {
      localStorage.clear()
      if (!this.$refs.loginForm.validate()) return
      this.spinner(true)
      try {
        await this.va_login({
          email: this.user.email,
          password: this.user.password
        })

        // // Patching business as unaopp
        // const url = `https://unoapp.dev.api.unoapp.io/api/v1/users/businesses/1`
        // const headers = {
        //   'api-token': apiToken,
        //   'auth-token': this.$store.getters['auth/user'].token
        // }
        // await axios({
        //   method: 'patch',
        //   url: url,
        //   headers: headers
        // }).catch(error => {
        // this.snackbar({ text: error.response.data.msg })
        // })

        await this.$store.dispatch('business/fetchUserBusinessList')
        this.$root.selectBusinessModal = true

        // push to locations page
      } catch (error) {
        this.spinner(false)
        return this.snackbar({ text: 'Incorrect Email or Password' })
      }

      // actions after logging in
      this.spinner(false)
    }
  },
  computed: {
    ...mapGetters({
      branding: 'business/activeBusinessBranding'
    })
  },
  watch: {},
  beforeDestroy () {}
}
</script>

<style lang="scss" scoped>
</style>
